import { render } from "./LesSecretariat.vue?vue&type=template&id=7f80260f&scoped=true&ts=true"
import script from "./LesSecretariat.vue?vue&type=script&lang=ts"
export * from "./LesSecretariat.vue?vue&type=script&lang=ts"

import "./LesSecretariat.vue?vue&type=style&index=0&id=7f80260f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f80260f"]])

export default __exports__